import { ref } from "vue";
import { defineStore } from "pinia";
import { filterCatalogueItems } from "@/modules/adminHub/serviceCatalogue/service/filterCatalogueItems";
import { fetchSize } from "@/config/constants";

export const useServiceCatalogueStore = defineStore("catalogueStore", () => {
  const catalogueList = ref(new Map());
  async function fetchCatalogueList(
    catalogueObj,
    includeSubCatalogues = false,
    onFirstPage?: (firstContent: any[]) => void,
    size: number = fetchSize.catalogue
  ) {
    const key = JSON.stringify({ catalogueObj, includeSubCatalogues });
    if (catalogueList.value.has(key)) {
      return catalogueList.value.get(key);
    }
    const response = await filterCatalogueItems(
      catalogueObj,
      includeSubCatalogues,
      (firstResponse) => {
        const firstContent = firstResponse?.content ?? [];
        catalogueList.value.set(key, firstContent);
        onFirstPage?.(firstContent);
      },
      size
    );
    catalogueList.value.set(key, response.content);
    return response.content;
  }
  function resetServiceCatalogueStore() {
    catalogueList.value.clear();
  }
  return {
    fetchCatalogueList,
    resetServiceCatalogueStore
  };
});
